import React, { createContext, useState, useContext } from "react";

const CompareContext = createContext();

export function useCompare() {
  return useContext(CompareContext);
}

export function CompareProvider({ children }) {
  const [compareList, setCompareList] = useState([]);

  const addToCompare = (product) => {
    setCompareList((prev) => {
      if (!prev.some((p) => p.barcode === product.barcode)) {
        return [...prev, product];
      }
      return prev;
    });
  };

  const removeFromCompare = (productBarcode) => {
    setCompareList((prev) => prev.filter((item) => item.barcode !== productBarcode));
  };

  const clearCompare = () => {
    setCompareList([]);
  };

  const value = {
    compareList,
    addToCompare,
    removeFromCompare,
    clearCompare,
  };

  return <CompareContext.Provider value={value}>{children}</CompareContext.Provider>;
}
